var PieChartModule = /** @class */ (function () {
    function PieChartModule() {
    }
    return PieChartModule;
}());
export { PieChartModule };
